import { render, staticRenderFns } from "./TicketsContactTooltip.component.vue?vue&type=template&id=0b7a2e39"
import script from "./TicketsContactTooltip.component.vue?vue&type=script&lang=js"
export * from "./TicketsContactTooltip.component.vue?vue&type=script&lang=js"
import style0 from "./TicketsContactTooltip.component.vue?vue&type=style&index=0&id=0b7a2e39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports